import React from 'react';
import KPIBentoGrid from './KPIBentoGrid';
import DashboardCharts from './DashboardCharts';
import RecentCheckIns from './RecentCheckIns';
import UpcomingBookings from './UpcomingBookings';

function getGreeting(): string {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}

function getTodayLabel(): string {
  return new Date().toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'short', year: 'numeric' });
}

export default function DashboardPage() {
  return (
    <div className="space-y-6">
      {/* Page header */}
      <div className="flex items-start justify-between">
        <div>
          <h1 className="text-[22px] font-bold text-foreground">{getGreeting()} 👋</h1>
          <p className="text-[13px] text-muted-foreground mt-0.5">
            Here's what's happening at ArenaSync today — {getTodayLabel()}
          </p>
        </div>
        <div className="hidden sm:flex items-center gap-2">
          <span className="flex items-center gap-1.5 text-[12px] text-success bg-success-bg border border-success/20 rounded-full px-3 py-1">
            <span className="w-1.5 h-1.5 bg-success rounded-full animate-pulse" />
            Live data
          </span>
        </div>
      </div>

      {/* KPI Bento Grid */}
      <KPIBentoGrid />

      {/* Charts Row */}
      <DashboardCharts />

      {/* Bottom row: check-ins + bookings */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <RecentCheckIns />
        <UpcomingBookings />
      </div>
    </div>
  );
}